/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AdminRole {
  REVIEWER = 'REVIEWER',
  STAFF = 'STAFF',
  OPERATOR = 'OPERATOR',
}
